import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { PlatformSDKVersionGroupSearchParam } from '../models/platform-sdk-version-group-search-param.model';
import { PlatformSDKVersionGroup } from '../models/platform-sdk-version-group.model';
import { AlloxApiService } from './allox-api.service';


@Injectable({ providedIn: 'root' })
export class PlatformSDKVersionGroupService {

  private path = '/platform_sdk_version_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: PlatformSDKVersionGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new PlatformSDKVersionGroup(obj)))
    );
  }

  public fetch(platformId: number, adFormat: number) {
    return this.http.get(this.path + '/' + platformId + '/' + adFormat).pipe(
      map(obj => new PlatformSDKVersionGroup(obj))
    );
  }

  public post(item: PlatformSDKVersionGroup) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: PlatformSDKVersionGroup) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }
}
